/// ////////////////////////////////////////////////////////////
/// ////////////////////////////////////////////////////////////
/// ////////////////////// Mandarin ////////////////////////////
/// ////////////////////////////////////////////////////////////
/// ////////////////////////////////////////////////////////////

export const data = {
    /// /////////////////////////////////////////////////////////
    /// /////////////// Header //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Main_Nav_Welcome: "欢迎",
    Main_Nav_HelpfulLinks: "有用的网址",
    Main_Nav_LogOut: "登出",
    Main_Nav_HelpfulLinks_LI_s1: "联系我的学生的护士",
    Main_Nav_HelpfulLinks_LI_s2: "学术日历",
    Main_Nav_HelpfulLinks_LI_s3: "家长资源",
    Main_Nav_HelpfulLinks_LI_s4: "公交路线",
    Main_Nav_HelpfulLinks_LI_s5: "在线支付",
    Main_Nav_HelpfulLinks_LI_s6: "午餐菜单",
    Main_Nav_Exit: "退出",
    Main_Nav_Tagline: "今日学习。明日领导。",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Global //////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Global_Add: "添加",
    Global_Close: "关闭",
    Global_Completed: "已完成",
    Global_InProgress: "进行中",
    Global_GoTo: "前往",
    Global_MoreInfo: "更多信息",
    Global_NotStarted: "未开始",
    Global_Open: "开放",
    Global_OpenFrom: "开放时间从 ", // [DATE] - [DATE]
    Global_Status: "状态",
    /// /////////////////////////////////////////////////////////
    /// /////////////// Breadcrumb //////////////////////////////
    /// /////////////////////////////////////////////////////////
    Breadcrumb: "DCSD 财务透明度",
    Breadcrumb_Translations: "翻译尚在实验阶段",
    /// /////////////////////////////////////////////////////////
    /// //////////////// Main ///////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Main_Instruction: (
        <ul>
            <li>此工具允许公众查询和导出道格拉斯县学区（DCSD）自 2017 年 7 月 1 日起的财务支出信息。</li>
            <li>
                在“资源”部分下查看适用于 DCSD 交易的{" "}
                <a
                    href="https://www.dcsdk12.org/about/departments/business-services/budget-and-accounting"
                    rel="noreferrer"
                    target="_blank"
                >
                    会计科目表
                </a>
                。
            </li>
            <li>在评估财务交易时，请考虑其背景。我们欢迎您就我们的财务交易或记录提出问题。</li>
        </ul>
    ),
    /// /////////////////////////////////////////////////////////
    /// /////////////// Faceted Search //////////////////////////
    /// /////////////////////////////////////////////////////////
    Facet_Keyword: "输入 关键词 此处",
    Facet_Export: "导出 CSV",
    Facet_Search: "搜索",
    /// /////////////////////////////////////////////////////////
    /// ///////////////// Forms /////////////////////////////////
    /// /////////////////////////////////////////////////////////
    Fiscal_Year: "财政年度",
    Fiscal_Year_Instruction: (
        <h5>
            您希望查看哪个<b>财政年度</b>？
        </h5>
    ),
    Quarter_Instruction: (
        <>
            <h5>
                您想查看哪个<b>季度</b>？
            </h5>
            <p>请选择一个可用的财政年度季度以生成初始结果集。无法选择未来的季度。</p>
        </>
    ),
    Quarter_View: "查看",
    /// /////////////////////////////////////////////////////////
    /// ///////////////// Results ///////////////////////////////
    /// /////////////////////////////////////////////////////////
    Results_Title: "搜索结果",
    Results_Instruction:
        "搜索结果如下所示。搜索结果可以通过“基金”、“地点”、“支付类型”和“支出类别”进行进一步细化。用户还可以使用“关键词搜索”在筛选结果中查找具体的支出信息。点击“导出CSV”按钮，可以将搜索结果导出（.csv格式）。",
    Results_No_Results: "无 支付 记录"
};
